export class CalendarEvent {
  label: string
  startTime: Date
  endTime: Date
  style:string
  props:any={}
  salle:string
  tags:any={}
  code_seance:number=0
  description:string=""

  constructor(label: string, startTime: Date, endTime: Date,salle:string,description:string="",code_seance:number=0,props:any={},style:string="") {
    this.label = label;
    this.startTime = startTime;
    this.endTime = endTime;
    this.style=style
    this.props=props
    this.code_seance=code_seance
    this.salle=salle
    this.description=description
  }
}
